import {
  CreateIssueRequestDto,
  CreateIssueResponseDto,
  useApi,
} from '@issuemanager/api-client';
import { ExtendedAxiosError } from '@issuemanager/apps/client/hooks';
import { useMutation, useQueryClient } from '@tanstack/react-query';

type UseCreateIssueOptions = {
  onSuccess?: (data: CreateIssueResponseDto) => void;
};

export function useCreateIssue(options: UseCreateIssueOptions) {
  const { onSuccess } = options;
  const api = useApi();
  const queryClient = useQueryClient();

  return useMutation<
    CreateIssueResponseDto,
    ExtendedAxiosError,
    CreateIssueRequestDto
  >({
    mutationKey: ['issues'],
    mutationFn: (r) => api.issuesApi.createIssue(r).then((r) => r.data),
    onSuccess: async (data) => {
      Promise.all([
        queryClient.invalidateQueries({ queryKey: ['issues'] }),
        queryClient.invalidateQueries({
          queryKey: ['users', 'roles'],
        }),
      ]);
      onSuccess?.(data);
    },
  });
}
